/**
 * SA-2 native (local-account) login feature flag.
 *
 * When `VITE_NATIVE_LOGIN_ENABLED` is truthy, the login page shows the
 * "Sign in with credentials" section for local accounts (users provisioned by
 * an admin who don't have a CloudEQ SSO identity). The section hands off to the
 * Cognito hosted login (password form) — the SPA never handles credentials.
 *
 * Split into its own module (not the component) so Vite's fast-refresh
 * `react-refresh/only-export-components` rule stays happy, and read at call
 * time (not captured at module load) so `vi.stubEnv` works in tests.
 *
 * This is a UI-visibility gate only. The real control is server-side:
 * the Cognito pool's `native_login_enabled` (adds the COGNITO provider) and
 * admin provisioning. Truthy (case-insensitive): `'true'`, `'1'`, `'yes'`.
 */

const TRUTHY = new Set(['true', '1', 'yes']);

export const isNativeLoginEnabled = (): boolean => {
  const raw = import.meta.env.VITE_NATIVE_LOGIN_ENABLED;
  if (typeof raw !== 'string') return false;
  return TRUTHY.has(raw.trim().toLowerCase());
};
